/* ==========================================================================
   bgc-choose.js — shared behavior for bgc-quiz, bgc-service, bgc-coverage
   Owned by AGENT-CHOOSE.

   Only bgc-quiz needs script-driven interactivity (the 3-question sizing
   quiz). bgc-service / bgc-coverage are static markup + the global reveal
   system (bgc-core.js handles [data-rv]/.rv — this file does not duplicate
   it). Ported from redesign/js/main.js "---------- quiz ----------" block,
   with the DOM-construction helper kept innerHTML-free and the hardcoded
   demo product data replaced by real product data read from a per-instance
   <script type="application/json" data-quiz-products> embedded by Liquid.

   IIFE + guard on element existence, per THEME-SPEC.md conventions. Also
   guards against the section markup (and this <script> tag) being included
   more than once on the same page, since each bgc-quiz/-service/-coverage
   section instance loads this same asset.
   ========================================================================== */
(function () {
  "use strict";

  if (window.__bgcChooseLoaded) return;
  window.__bgcChooseLoaded = true;

  /* tiny DOM helper — element with class/text only (no HTML parsing) */
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  /* ---------- quiz ---------- */

  var QUIZ_QUESTIONS = [
    { q: "How many people eat at home?", opts: [["1–3", 0], ["4–6", 1], ["7+", 2], ["It's a business", 3]] },
    { q: "How many burners do you cook on?", opts: [["1–2", 0], ["3–4", 1], ["5+", 2]] },
    { q: "How often do you cook?", opts: [["Once a day", 0], ["Every meal", 1], ["All day — it's commercial", 2]] }
  ];

  var QUIZ_WHO = {
    "5": "Perfect for small households and outdoor cooking.",
    "10": "The everyday choice for most family kitchens.",
    "13": "Built for big families and commercial kitchens."
  };

  function readQuizProducts(root) {
    var dataEl = root.querySelector("script[data-quiz-products]");
    if (!dataEl) return {};
    try {
      return JSON.parse(dataEl.textContent || "{}") || {};
    } catch (e) {
      return {};
    }
  }

  function initQuiz(root) {
    var body = root.querySelector("[data-quiz-body]");
    var dots = root.querySelectorAll(".bgc-quiz-dots i");
    if (!body) return;

    var products = readQuizProducts(root);
    var step = 0;
    var score = 0;

    function buildQuestion(q) {
      var frag = document.createDocumentFragment();
      frag.appendChild(el("div", "bgc-quiz-q", q.q));
      var opts = el("div", "bgc-quiz-opts");
      q.opts.forEach(function (pair) {
        var label = pair[0];
        var val = pair[1];
        var b = el("button", "bgc-quiz-opt", label);
        b.type = "button";
        b.addEventListener("click", function () {
          score += val;
          step++;
          render();
        });
        opts.appendChild(b);
      });
      frag.appendChild(opts);
      return frag;
    }

    function buildResult() {
      var key = score >= 5 ? "13" : score >= 2 ? "10" : "5";
      var p = products[key];
      var box = el("div", "bgc-quiz-result");
      box.appendChild(el("div", "eyebrow", "Our recommendation"));

      if (p) {
        if (p.image) {
          var img = document.createElement("img");
          img.src = p.image; /* attribute assignment — not innerHTML */
          img.alt = p.title || key + "kg Composite";
          img.loading = "lazy";
          box.appendChild(img);
        }
        box.appendChild(el("div", "bgc-quiz-q", p.title || key + "kg Composite"));
        box.appendChild(el("p", "bgc-quiz-who", QUIZ_WHO[key] || ""));
        if (p.price) box.appendChild(el("div", "bgc-quiz-price", p.price));

        var actions = el("div", "bgc-quiz-actions");

        var buy = el("button", "btn btn-flame", "Add to cart");
        buy.type = "button";
        if (p.variantId) {
          buy.addEventListener("click", function () {
            if (window.BGC && typeof window.BGC.addToCart === "function") {
              window.BGC.addToCart(p.variantId, 1);
            }
          });
        } else {
          buy.disabled = true;
        }
        actions.appendChild(buy);

        if (p.url) {
          var view = el("a", "btn btn-ghost", "View product");
          view.href = p.url;
          actions.appendChild(view);
        }

        box.appendChild(actions);
      } else {
        box.appendChild(el("div", "bgc-quiz-q", key + "kg Composite"));
        box.appendChild(el("p", "bgc-quiz-who", QUIZ_WHO[key] || ""));
      }

      var resetWrap = el("div", "bgc-quiz-reset-wrap");
      var reset = el("button", "bgc-quiz-reset", "Start over");
      reset.type = "button";
      reset.addEventListener("click", function () {
        step = 0;
        score = 0;
        render();
      });
      resetWrap.appendChild(reset);
      box.appendChild(resetWrap);

      return box;
    }

    function render() {
      dots.forEach(function (d, i) {
        d.classList.toggle("on", i <= step && step < QUIZ_QUESTIONS.length);
      });
      var next = el("div", "bgc-quiz-step in");
      next.appendChild(step < QUIZ_QUESTIONS.length ? buildQuestion(QUIZ_QUESTIONS[step]) : buildResult());
      var old = body.querySelector(".bgc-quiz-step");
      if (old) {
        old.classList.add("out");
        setTimeout(function () {
          if (old.parentNode) old.parentNode.removeChild(old);
        }, 400);
      }
      body.appendChild(next);
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          next.classList.remove("in");
        });
      });
    }

    render();
  }

  var quizzes = document.querySelectorAll("[data-quiz]");
  if (quizzes.length) {
    quizzes.forEach(initQuiz);
  }
})();
